function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  "class": "az-shell"
};
var _hoisted_2 = {
  key: 0,
  "class": "az-embed-hero"
};
var _hoisted_3 = {
  "class": "az-layout"
};
var _hoisted_4 = {
  "class": "az-stack"
};
var _hoisted_5 = {
  "class": "az-card az-panel"
};
var _hoisted_6 = {
  "class": "az-plan-grid"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  "class": "az-plan-copy"
};
var _hoisted_9 = {
  "class": "t"
};
var _hoisted_10 = {
  "class": "s"
};
var _hoisted_11 = {
  "class": "az-top-gap"
};
var _hoisted_12 = {
  "class": "az-seg"
};
var _hoisted_13 = {
  "class": "az-card az-panel"
};
var _hoisted_14 = {
  "class": "az-grid2"
};
var _hoisted_15 = {
  "class": "az-grid2 az-top-gap"
};
var _hoisted_16 = {
  "class": "az-field"
};
var _hoisted_17 = {
  "class": "az-inwrap az-field-input"
};
var _hoisted_18 = ["value"];
var _hoisted_19 = ["value"];
var _hoisted_20 = {
  key: 0,
  "class": "az-field"
};
var _hoisted_21 = {
  "class": "az-inwrap az-field-input"
};
var _hoisted_22 = ["value"];
var _hoisted_23 = ["value"];
var _hoisted_24 = {
  "class": "az-meta az-faint"
};
var _hoisted_25 = {
  key: 0,
  "class": "az-warning"
};
var _hoisted_26 = {
  "class": "az-advanced"
};
var _hoisted_27 = {
  "class": "az-advanced-title"
};
var _hoisted_28 = {
  key: 0,
  "class": "az-stack-sm az-top-gap"
};
var _hoisted_29 = {
  "class": "az-grid2"
};
var _hoisted_30 = {
  "class": "az-card az-panel"
};
var _hoisted_31 = {
  "class": "az-disp az-section-head"
};
var _hoisted_32 = {
  "class": "az-stack-xs"
};
var _hoisted_33 = {
  "class": "az-compare-track"
};
var _hoisted_34 = {
  "class": "az-result-col"
};
var _hoisted_35 = {
  "class": "az-hero-head"
};
var _hoisted_36 = {
  "class": "az-hero-label"
};
var _hoisted_37 = {
  "class": "az-hero-metrics"
};
var _hoisted_38 = {
  "class": "az-num az-hero-metric-value"
};
var _hoisted_39 = {
  key: 0
};
var _hoisted_40 = {
  "class": "az-num az-hero-metric-value"
};
var _hoisted_41 = {
  "class": "az-num az-hero-metric-value"
};
var _hoisted_42 = {
  "class": "az-top-gap-lg"
};
var _hoisted_43 = {
  "class": "az-segment-bar"
};
var _hoisted_44 = ["title"];
var _hoisted_45 = {
  "class": "az-legend"
};
var _hoisted_46 = {
  key: 0,
  "class": "az-warning"
};
var _hoisted_47 = {
  "class": "az-card az-panel"
};
var _hoisted_48 = {
  "class": "az-breakdown-group"
};
var _hoisted_49 = {
  "class": "az-breakdown-block"
};
var _hoisted_50 = {
  "class": "az-breakdown-block"
};
var _hoisted_51 = {
  "class": "az-breakdown-block"
};
var _hoisted_52 = {
  "class": "az-breakdown-foot"
};
var _hoisted_53 = {
  "class": "az-card az-panel"
};
var _hoisted_54 = {
  "class": "az-disp az-section-head"
};
var _hoisted_55 = {
  "class": "az-seg az-top-gap"
};
var _hoisted_56 = ["onClick"];
var _hoisted_57 = {
  key: 0,
  "class": "az-output-card az-top-gap"
};
var _hoisted_58 = {
  "class": "az-num az-disp az-output-value"
};
var _hoisted_59 = {
  key: 1,
  "class": "az-stack-sm az-top-gap"
};
var _hoisted_60 = {
  "class": "az-grid2"
};
var _hoisted_61 = {
  "class": "az-output-card"
};
var _hoisted_62 = {
  "class": "az-num az-disp az-output-value az-output-value-sm"
};
var _hoisted_63 = {
  "class": "az-output-card"
};
var _hoisted_64 = {
  key: 2,
  "class": "az-stack-sm az-top-gap"
};
var _hoisted_65 = {
  "class": "az-output-card"
};
var _hoisted_66 = {
  "class": "az-output-label"
};
var _hoisted_67 = {
  "class": "az-num az-disp az-output-value"
};
var _hoisted_68 = {
  key: 0,
  "class": "az-output-note az-faint"
};
var _hoisted_69 = {
  key: 1,
  "class": "az-card az-panel az-embed-card"
};
var _hoisted_70 = ["value"];
var _hoisted_71 = {
  "class": "az-embed-actions"
};
var _hoisted_72 = {
  key: 2,
  "class": "az-powered"
};
var _hoisted_73 = {
  "class": "az-modal-card"
};
var _hoisted_74 = {
  "class": "az-modal-head"
};
var _hoisted_75 = {
  "class": "az-modal-body"
};
var _hoisted_76 = {
  "class": "az-preview-wrap"
};
var _hoisted_77 = ["src"];
import { computed, defineComponent, h, reactive, ref } from 'vue';
import { TOOL_EMBED_PROPS, buildEmbedSnippet, useToolEmbedSupport } from './shared/toolEmbed';
import { useTimedFlag, writeToClipboard } from './shared/toolClipboard';
var MEDIA_CLOSING = 1.0;
var GST = 1.1;
export default {
  __name: 'amazonAuCalculator',
  props: TOOL_EMBED_PROPS,
  setup: function setup(__props) {
    var props = __props;
    var BRAND = {
      brand: '#0072d6',
      brand600: '#0061b6',
      brandSoft: '#e8f2fc',
      ring: '#cce3f7',
      ink: '#222a44',
      text: '#1f1f1f',
      muted: '#5d6772',
      faint: '#99a1ac',
      line: '#e4e8ee',
      bg: '#f4f7fa',
      surface: '#ffffff',
      pos: '#00c489',
      pos700: '#0a8a63',
      posSoft: '#e6f8f1',
      neg: '#ff492c',
      negSoft: '#ffe9e4',
      warn: '#ffa127',
      warnSoft: '#fff2e0',
      pink: '#ff3969'
    };
    var PLANS = {
      professional: {
        label: 'Professional',
        sub: '$49.95/mo',
        perItem: 0,
        monthly: 49.95
      },
      individual: {
        label: 'Individual',
        sub: '$0.99/item',
        perItem: 0.99,
        monthly: 0
      }
    };
    var PLAN_KEYS = Object.keys(PLANS);
    var PLAN_ICONS = {
      professional: 'building2',
      individual: 'user'
    };
    var REF = {
      alcohol: {
        flat: 0.10
      },
      automotive: {
        flat: 0.105
      },
      baby: {
        thr: 20,
        lo: 0.08,
        hi: 0.11
      },
      powertools: {
        flat: 0.07
      },
      beauty: {
        thr: 20,
        lo: 0.08,
        hi: 0.13
      },
      business: {
        flat: 0.11
      },
      clothing: {
        thr: 20,
        lo: 0.10,
        hi: 0.13
      },
      computers: {
        tier: 150,
        lo: 0.08,
        hi: 0.06
      },
      electronics: {
        flat: 0.08
      },
      elecaccess: {
        flat: 0.135
      },
      furniture: {
        flat: 0.12
      },
      grocery: {
        thr: 20,
        lo: 0.08,
        hi: 0.10
      },
      homekitchen: {
        flat: 0.13
      },
      homeappliance: {
        flat: 0.08
      },
      jewellery: {
        tier: 200,
        lo: 0.15,
        hi: 0.05
      },
      lawngarden: {
        flat: 0.105
      },
      luggage: {
        flat: 0.13
      },
      majorappliance: {
        flat: 0.07
      },
      media: {
        flat: 0.15,
        media: true
      },
      musicinstr: {
        flat: 0.11
      },
      office: {
        flat: 0.13
      },
      pet: {
        thr: 20,
        lo: 0.10,
        hi: 0.13
      },
      shoes: {
        tier: 50,
        lo: 0.14,
        hi: 0.10
      },
      sports: {
        tier: 200,
        lo: 0.13,
        hi: 0.12
      },
      tools: {
        thr: 20,
        lo: 0.10,
        hi: 0.13
      },
      toys: {
        flat: 0.12
      },
      tyres: {
        flat: 0.09
      },
      consoles: {
        flat: 0.06,
        media: true
      },
      videogames: {
        flat: 0.09,
        media: true
      },
      watches: {
        tier: 50,
        lo: 0.12,
        hi: 0.08
      },
      everything: {
        flat: 0.15
      }
    };
    var CATS = [['alcohol', 'Alcoholic beverages'], ['automotive', 'Automotive & powersports'], ['baby', 'Baby products'], ['powertools', 'Base equipment power tools'], ['beauty', 'Beauty, health & personal care'], ['business', 'Business, industrial & scientific'], ['clothing', 'Clothing & accessories'], ['computers', 'Computers'], ['electronics', 'Consumer electronics'], ['elecaccess', 'Electronics accessories'], ['furniture', 'Furniture'], ['grocery', 'Grocery & gourmet'], ['homekitchen', 'Home & kitchen'], ['homeappliance', 'Home & kitchen appliances'], ['jewellery', 'Jewellery'], ['lawngarden', 'Lawn & garden'], ['luggage', 'Luggage'], ['majorappliance', 'Major domestic appliances'], ['media', 'Media — books, DVD, music, video'], ['musicinstr', 'Musical instruments & AV'], ['office', 'Office products'], ['pet', 'Pet products'], ['shoes', 'Shoes, handbags & sunglasses'], ['sports', 'Sports & outdoors'], ['tools', 'Tools & home improvement'], ['toys', 'Toys & games'], ['tyres', 'Tyres'], ['consoles', 'Video game consoles'], ['videogames', 'Video games & accessories'], ['watches', 'Watches'], ['everything', 'Everything else']].map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        id = _ref2[0],
        label = _ref2[1];
      return {
        id: id,
        label: label
      };
    });
    var SORTED_CATS = _toConsumableArray(CATS).sort(function (a, b) {
      if (a.id === 'everything') {
        return 1;
      }
      if (b.id === 'everything') {
        return -1;
      }
      return a.label.localeCompare(b.label);
    });
    var TIERS = [{
      id: 'smallenv',
      label: 'Small envelope',
      dims: '≤ 20×15×1 cm · ≤ 75 g'
    }, {
      id: 'stdenv',
      label: 'Standard envelope',
      dims: '≤ 33×23×2.5 cm · ≤ 475 g'
    }, {
      id: 'largeenv',
      label: 'Large envelope',
      dims: '≤ 33×23×5 cm · ≤ 975 g'
    }, {
      id: 'parcel',
      label: 'Parcel',
      dims: '≤ 45×34×20 cm · ≤ 12 kg'
    }, {
      id: 'smalloversize',
      label: 'Small oversize',
      dims: '≤ 61×46×46 cm · ≤ 2 kg'
    }, {
      id: 'stdoversize',
      label: 'Standard oversize',
      dims: '≤ 105×60×60 cm · ≤ 22 kg'
    }, {
      id: 'largeoversize',
      label: 'Large oversize',
      dims: '> 105×60×60 cm · ≤ 35 kg'
    }, {
      id: 'extralarge',
      label: 'Extra large',
      dims: '> 35 kg'
    }];
    var FBA = {
      smallenv: {
        bands: [{
          max: 75,
          hi: 4.55,
          lo: 3.64
        }]
      },
      stdenv: {
        bands: [{
          max: 75,
          hi: 4.58,
          lo: 3.67
        }, {
          max: 225,
          hi: 5.26,
          lo: 4.35
        }, {
          max: 475,
          hi: 5.61,
          lo: 4.70
        }]
      },
      largeenv: {
        bands: [{
          max: 225,
          hi: 6.78,
          lo: 5.87
        }, {
          max: 475,
          hi: 7.02,
          lo: 6.11
        }, {
          max: 975,
          hi: 8.29,
          lo: 7.38
        }]
      },
      parcel: {
        bands: [{
          max: 250,
          hi: 7.34,
          lo: 6.43
        }, {
          max: 500,
          hi: 7.64,
          lo: 6.73
        }, {
          max: 1000,
          hi: 9.22,
          lo: 8.31
        }, {
          max: 1500,
          hi: 9.68,
          lo: 8.77
        }, {
          max: 2000,
          hi: 9.81,
          lo: 8.90
        }, {
          max: 3000,
          hi: 9.86,
          lo: 8.95
        }, {
          max: 4000,
          hi: 10.18,
          lo: 9.27
        }, {
          max: 5000,
          hi: 10.19,
          lo: 9.28
        }, {
          max: 6000,
          hi: 11.10,
          lo: 10.19
        }, {
          max: 7000,
          hi: 11.26,
          lo: 10.35
        }, {
          max: 8000,
          hi: 11.26,
          lo: 10.35
        }, {
          max: 9000,
          hi: 11.27,
          lo: 10.36
        }, {
          max: 10000,
          hi: 11.27,
          lo: 10.36
        }, {
          max: 11000,
          hi: 13.80,
          lo: 12.89
        }, {
          max: 12000,
          hi: 13.93,
          lo: 13.02
        }]
      },
      smalloversize: {
        bands: [{
          max: 1000,
          hi: 9.94,
          lo: 9.03
        }, {
          max: 1250,
          hi: 10.41,
          lo: 9.50
        }, {
          max: 1500,
          hi: 10.65,
          lo: 9.74
        }, {
          max: 1750,
          hi: 10.66,
          lo: 9.75
        }, {
          max: 2000,
          hi: 10.66,
          lo: 9.75
        }],
        over: {
          hi: 10.68,
          lo: 9.77,
          perKg: 0.01,
          overKg: 2
        }
      },
      stdoversize: {
        bands: [{
          max: 1000,
          hi: 12.30,
          lo: 11.39
        }, {
          max: 2000,
          hi: 12.95,
          lo: 12.04
        }, {
          max: 3000,
          hi: 13.04,
          lo: 12.13
        }, {
          max: 4000,
          hi: 13.18,
          lo: 12.27
        }, {
          max: 5000,
          hi: 13.41,
          lo: 12.50
        }, {
          max: 6000,
          hi: 14.31,
          lo: 13.40
        }, {
          max: 7000,
          hi: 14.46,
          lo: 13.55
        }, {
          max: 8000,
          hi: 14.48,
          lo: 13.57
        }, {
          max: 9000,
          hi: 14.52,
          lo: 13.61
        }, {
          max: 10000,
          hi: 14.52,
          lo: 13.61
        }, {
          max: 15000,
          hi: 15.86,
          lo: 14.95
        }, {
          max: 20000,
          hi: 16.42,
          lo: 15.51
        }, {
          max: 22000,
          hi: 16.42,
          lo: 15.51
        }],
        over: {
          hi: 16.43,
          lo: 15.52,
          perKg: 0.01,
          overKg: 22
        }
      },
      largeoversize: {
        bands: [{
          max: 5000,
          hi: 14.71,
          lo: 13.80
        }, {
          max: 10000,
          hi: 15.12,
          lo: 14.21
        }, {
          max: 15000,
          hi: 16.02,
          lo: 15.11
        }, {
          max: 20000,
          hi: 16.52,
          lo: 15.61
        }, {
          max: 25000,
          hi: 16.56,
          lo: 15.65
        }, {
          max: 30000,
          hi: 23.00,
          lo: 22.09
        }, {
          max: 35000,
          hi: 24.00,
          lo: 23.09
        }],
        over: {
          hi: 34.00,
          lo: 33.09,
          perKg: 0.10,
          overKg: 35
        }
      },
      extralarge: {
        bands: [{
          max: 35000,
          hi: 72.00,
          lo: 71.09
        }],
        over: {
          hi: 72.00,
          lo: 71.09,
          perKg: 0.10,
          overKg: 35
        }
      }
    };
    var REVERSE_TABS = [{
      key: 'breakeven',
      label: 'Breakeven'
    }, {
      key: 'profit',
      label: 'Target $'
    }, {
      key: 'margin',
      label: 'Target %'
    }];
    var ICONS = {
      info: [{
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 10
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 16v-4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 8h.01'
        }
      }],
      chevronDown: [{
        tag: 'path',
        attrs: {
          d: 'm6 9 6 6 6-6'
        }
      }],
      chevronRight: [{
        tag: 'path',
        attrs: {
          d: 'm9 18 6-6-6-6'
        }
      }],
      rotateCcw: [{
        tag: 'path',
        attrs: {
          d: 'M3 2v6h6'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M3 8a9 9 0 1 0 3-6.7L3 4'
        }
      }],
      copy: [{
        tag: 'rect',
        attrs: {
          x: 9,
          y: 9,
          width: 13,
          height: 13,
          rx: 2,
          ry: 2
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'
        }
      }],
      check: [{
        tag: 'path',
        attrs: {
          d: 'M20 6 9 17l-5-5'
        }
      }],
      alertTriangle: [{
        tag: 'path',
        attrs: {
          d: 'm10.29 3.86-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.71-3.14l-8-14a2 2 0 0 0-3.42 0Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 9v4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 17h.01'
        }
      }],
      trendingUp: [{
        tag: 'path',
        attrs: {
          d: 'm22 7-8.5 8.5-5-5L2 17'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M16 7h6v6'
        }
      }],
      target: [{
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 10
        }
      }, {
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 6
        }
      }, {
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 2
        }
      }],
      layers: [{
        tag: 'path',
        attrs: {
          d: 'm12.83 2.18 8 4a1 1 0 0 1 0 1.64l-8 4a2 2 0 0 1-1.66 0l-8-4a1 1 0 0 1 0-1.64l8-4a2 2 0 0 1 1.66 0Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm2 12 9.17 4.59a2 2 0 0 0 1.66 0L22 12'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm2 16 9.17 4.59a2 2 0 0 0 1.66 0L22 16'
        }
      }],
      user: [{
        tag: 'path',
        attrs: {
          d: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2'
        }
      }, {
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 7,
          r: 4
        }
      }],
      building2: [{
        tag: 'path',
        attrs: {
          d: 'M6 22V4a1 1 0 0 1 1-1h7l4 4v15'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M18 22H4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M10 8h4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M10 12h4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M10 16h4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3'
        }
      }],
      x: [{
        tag: 'path',
        attrs: {
          d: 'M18 6 6 18'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm6 6 12 12'
        }
      }]
    };
    var SvgIcon = defineComponent({
      name: 'AmazonAuSvgIcon',
      inheritAttrs: false,
      props: {
        name: {
          type: String,
          required: true
        },
        size: {
          type: [Number, String],
          "default": 24
        }
      },
      setup: function setup(componentProps, _ref3) {
        var attrs = _ref3.attrs;
        return function () {
          var nodes = ICONS[componentProps.name] || [];
          return h('svg', _objectSpread(_objectSpread({}, attrs), {}, {
            xmlns: 'http://www.w3.org/2000/svg',
            width: componentProps.size,
            height: componentProps.size,
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': 2,
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'aria-hidden': 'true'
          }), nodes.map(function (node, index) {
            return h(node.tag, _objectSpread({
              key: "".concat(componentProps.name, "-").concat(index)
            }, node.attrs));
          }));
        };
      }
    });
    var FieldInput = defineComponent({
      name: 'AmazonAuFieldInput',
      props: {
        label: {
          type: String,
          required: true
        },
        hint: {
          type: String,
          "default": ''
        },
        modelValue: {
          type: [Number, String],
          "default": 0
        },
        prefix: {
          type: String,
          "default": '$'
        },
        step: {
          type: [String, Number],
          "default": '0.01'
        }
      },
      emits: ['update:modelValue'],
      setup: function setup(componentProps, _ref4) {
        var emit = _ref4.emit;
        function onInput(event) {
          var nextValue = event.target.value;
          var parsed = Number.parseFloat(nextValue);
          emit('update:modelValue', nextValue === '' || Number.isNaN(parsed) ? 0 : Math.max(0, parsed));
        }
        return function () {
          return h('label', {
            "class": 'az-field'
          }, [h('span', {
            "class": 'az-label'
          }, [componentProps.label, componentProps.hint ? h('span', {
            "class": 'az-tip'
          }, [h(SvgIcon, {
            name: 'info',
            size: 14,
            style: {
              color: BRAND.faint
            }
          }), h('span', {
            "class": 'b'
          }, componentProps.hint)]) : null]), h('div', {
            "class": 'az-inwrap az-field-input'
          }, [componentProps.prefix !== '' ? h('span', {
            "class": 'az-pre'
          }, componentProps.prefix) : null, h('input', {
            "class": 'az-num',
            type: 'number',
            inputmode: 'decimal',
            step: componentProps.step,
            min: '0',
            value: componentProps.modelValue,
            onInput: onInput
          })])]);
        };
      }
    });
    var ToggleCard = defineComponent({
      name: 'AmazonAuToggleCard',
      props: {
        label: {
          type: String,
          required: true
        },
        hint: {
          type: String,
          "default": ''
        },
        checked: {
          type: Boolean,
          "default": false
        }
      },
      emits: ['update:checked'],
      setup: function setup(componentProps, _ref5) {
        var emit = _ref5.emit;
        return function () {
          return h('button', {
            type: 'button',
            role: 'switch',
            'aria-checked': componentProps.checked,
            "class": 'az-chip az-toggle-card',
            onClick: function onClick() {
              return emit('update:checked', !componentProps.checked);
            }
          }, [h('span', {
            "class": 'az-toggle-text'
          }, [componentProps.label, componentProps.hint ? h('span', {
            "class": 'az-toggle-hint'
          }, " \xB7 ".concat(componentProps.hint)) : null]), h('span', {
            "class": ['az-switch', {
              on: componentProps.checked
            }]
          }, [h('i')])]);
        };
      }
    });
    var BreakdownRow = defineComponent({
      name: 'AmazonAuBreakdownRow',
      props: {
        label: {
          type: String,
          required: true
        },
        value: {
          type: String,
          required: true
        },
        sub: {
          type: String,
          "default": ''
        },
        tone: {
          type: String,
          "default": 'default'
        },
        strong: {
          type: Boolean,
          "default": false
        }
      },
      setup: function setup(componentProps) {
        return function () {
          var color = componentProps.tone === 'neg' ? BRAND.neg : componentProps.tone === 'pos' ? BRAND.pos700 : componentProps.strong ? BRAND.ink : BRAND.muted;
          return h('div', {
            "class": 'az-row'
          }, [h('span', {
            "class": 'az-row-label',
            style: {
              color: componentProps.strong ? BRAND.ink : BRAND.muted,
              fontWeight: componentProps.strong ? 600 : 400
            }
          }, [componentProps.label, componentProps.sub ? h('span', {
            "class": 'az-row-sub'
          }, componentProps.sub) : null]), h('span', {
            "class": ['az-num', 'az-row-value', {
              'az-row-value-strong': componentProps.strong
            }],
            style: {
              color: color
            }
          }, componentProps.value)]);
        };
      }
    });
    function referral(catId, total) {
      var category = REF[catId] || REF.everything;
      if (category.flat != null) {
        return category.flat * total;
      }
      if (category.thr != null) {
        return (total <= category.thr ? category.lo : category.hi) * total;
      }
      return category.lo * Math.min(total, category.tier) + category.hi * Math.max(0, total - category.tier);
    }
    function fbaFee(tier, weightG, price) {
      var tierData = FBA[tier];
      if (!tierData) {
        return 0;
      }
      var cheap = price < 13;
      var _iterator = _createForOfIteratorHelper(tierData.bands),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var band = _step.value;
          if (weightG <= band.max) {
            return cheap ? band.lo : band.hi;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (tierData.over) {
        return (cheap ? tierData.over.lo : tierData.over.hi) + tierData.over.perKg * Math.max(0, weightG / 1000 - tierData.over.overKg);
      }
      var lastBand = tierData.bands[tierData.bands.length - 1];
      return cheap ? lastBand.lo : lastBand.hi;
    }
    function compute(state, priceOverride) {
      var price = priceOverride !== null && priceOverride !== void 0 ? priceOverride : state.soldPrice;
      var total = price + state.shippingCharged;
      var category = REF[state.categoryId] || REF.everything;
      var referralFee = 0;
      var perItem = 0;
      var mediaClosing = 0;
      var fba = 0;
      var subPerUnit = 0;
      if (total > 0) {
        referralFee = referral(state.categoryId, total);
        perItem = PLANS[state.plan].perItem;
        mediaClosing = category.media ? MEDIA_CLOSING : 0;
        subPerUnit = state.plan === 'professional' && state.unitsPerMonth > 0 ? PLANS.professional.monthly / state.unitsPerMonth : 0;
        if (state.fulfilment === 'fba') {
          fba = state.fbaOverride > 0 ? state.fbaOverride : fbaFee(state.sizeTier, state.weightG, price);
        }
      }
      var shipCost = state.fulfilment === 'fbm' ? state.shippingCost : 0;
      var amazon = referralFee + perItem + mediaClosing + fba + subPerUnit;
      if (state.gstOnFees) {
        amazon *= GST;
      }
      var gstOnRevenue = state.remitGst ? total * (state.gstRate / (100 + state.gstRate)) : 0;
      var cashCosts = state.itemCost + shipCost + state.storagePrep + state.advertising + state.otherCosts;
      var netProfit = total - amazon - cashCosts - gstOnRevenue;
      var gstFactor = state.gstOnFees ? GST : 1;
      return {
        total: total,
        referralFee: referralFee * gstFactor,
        perItem: perItem * gstFactor,
        mediaClosing: mediaClosing * gstFactor,
        fba: fba * gstFactor,
        subPerUnit: subPerUnit * gstFactor,
        shipCost: shipCost,
        amazon: amazon,
        gstOnRevenue: gstOnRevenue,
        costs: cashCosts,
        totalFees: amazon,
        netProfit: netProfit,
        margin: total > 0 ? netProfit / total : 0,
        roi: cashCosts > 0 ? netProfit / cashCosts : null,
        effFeeRate: total > 0 ? amazon / total : 0,
        refRate: total > 0 ? referralFee / total : 0
      };
    }
    function solve(state, targetFn) {
      var low = 0;
      var high = 1000000;
      for (var index = 0; index < 80; index += 1) {
        var mid = (low + high) / 2;
        if (targetFn(compute(state, mid)) > 0) {
          high = mid;
        } else {
          low = mid;
        }
      }
      return (low + high) / 2;
    }
    function fmt(value) {
      return Number.isFinite(value) ? value.toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) : '—';
    }
    function pct(value) {
      return Number.isFinite(value) ? "".concat((value * 100).toFixed(1), "%") : '—';
    }
    function notAchievable(value) {
      return !(value < 999000);
    }
    var defaults = {
      soldPrice: 39.95,
      shippingCharged: 0,
      itemCost: 12,
      categoryId: 'everything',
      plan: 'professional',
      fulfilment: 'fba',
      sizeTier: 'smallenv',
      weightG: 75,
      shippingCost: 7,
      unitsPerMonth: 200,
      fbaOverride: 0,
      storagePrep: 0,
      advertising: 0,
      otherCosts: 0,
      gstOnFees: false,
      remitGst: false,
      gstRate: 10
    };
    var blank = _objectSpread(_objectSpread({}, defaults), {}, {
      soldPrice: 0,
      shippingCharged: 0,
      itemCost: 0,
      weightG: 0,
      shippingCost: 0
    });
    var inputs = reactive(_objectSpread({}, defaults));
    var showAdvanced = ref(false);
    var reverseTab = ref('breakeven');
    var targetProfit = ref(8);
    var targetMargin = ref(20);
    var _useTimedFlag = useTimedFlag(1500),
      copied = _useTimedFlag.flag,
      triggerCopied = _useTimedFlag.trigger,
      resetCopied = _useTimedFlag.reset;
    var _useTimedFlag2 = useTimedFlag(1500),
      embedCopied = _useTimedFlag2.flag,
      triggerEmbedCopied = _useTimedFlag2.trigger,
      resetEmbedCopied = _useTimedFlag2.reset;
    var _useToolEmbedSupport = useToolEmbedSupport({
        props: props
      }),
      rootRef = _useToolEmbedSupport.rootRef,
      previewFrameRef = _useToolEmbedSupport.previewFrameRef,
      showPreview = _useToolEmbedSupport.showPreview,
      isEmbed = _useToolEmbedSupport.isEmbed,
      pageUrl = _useToolEmbedSupport.pageUrl,
      previewSrc = _useToolEmbedSupport.previewSrc,
      showEmbedCard = _useToolEmbedSupport.showEmbedCard,
      closePreview = _useToolEmbedSupport.closePreview;
    function setValue(key, value) {
      inputs[key] = value;
    }
    var result = computed(function () {
      return compute(inputs);
    });
    var catLabel = computed(function () {
      var _CATS$find;
      return ((_CATS$find = CATS.find(function (category) {
        return category.id === inputs.categoryId;
      })) === null || _CATS$find === void 0 ? void 0 : _CATS$find.label) || 'Everything else';
    });
    var loss = computed(function () {
      return result.value.netProfit < 0;
    });
    var breakeven = computed(function () {
      return solve(inputs, function (current) {
        return current.netProfit;
      });
    });
    var priceForProfit = computed(function () {
      return solve(inputs, function (current) {
        return current.netProfit - targetProfit.value;
      });
    });
    var priceForMargin = computed(function () {
      return solve(inputs, function (current) {
        return current.netProfit - targetMargin.value / 100 * current.total;
      });
    });
    var maxItemCost = computed(function () {
      return inputs.itemCost + (result.value.netProfit - targetProfit.value);
    });
    var hasBasis = computed(function () {
      return inputs.soldPrice > 0 || inputs.shippingCharged > 0 || inputs.itemCost > 0;
    });
    var planCompare = computed(function () {
      return PLAN_KEYS.map(function (key) {
        return _objectSpread(_objectSpread({
          key: key
        }, PLANS[key]), {}, {
          net: compute(_objectSpread(_objectSpread({}, inputs), {}, {
            plan: key
          })).netProfit
        });
      });
    });
    var tierData = computed(function () {
      return FBA[inputs.sizeTier];
    });
    var tierMaxWeight = computed(function () {
      return tierData.value && !tierData.value.over ? tierData.value.bands[tierData.value.bands.length - 1].max : null;
    });
    var tierOverflow = computed(function () {
      return inputs.fulfilment === 'fba' && !inputs.fbaOverride && tierMaxWeight.value != null && inputs.weightG > tierMaxWeight.value;
    });
    var tierMaxLabel = computed(function () {
      if (tierMaxWeight.value == null) {
        return '';
      }
      return tierMaxWeight.value >= 1000 ? "".concat(tierMaxWeight.value / 1000, " kg") : "".concat(tierMaxWeight.value, " g");
    });
    var maxMargin = computed(function () {
      return compute(inputs, 1000000).margin;
    });
    var segments = computed(function () {
      return [{
        label: 'Amazon fees',
        value: Math.max(result.value.totalFees, 0),
        color: BRAND.pink
      }, {
        label: result.value.shipCost > 0 ? 'Shipping' : '',
        value: result.value.shipCost,
        color: '#9cc6ee'
      }, {
        label: 'Item cost',
        value: inputs.itemCost,
        color: '#8a93a4'
      }, {
        label: 'Other + GST',
        value: inputs.storagePrep + inputs.advertising + inputs.otherCosts + result.value.gstOnRevenue,
        color: '#c2cdd6'
      }, {
        label: loss.value ? 'Loss' : 'Your profit',
        value: Math.abs(result.value.netProfit),
        color: loss.value ? BRAND.neg : BRAND.pos
      }].filter(function (segment) {
        return segment.value > 0 && segment.label;
      });
    });
    var segmentTotal = computed(function () {
      return segments.value.reduce(function (total, segment) {
        return total + segment.value;
      }, 0) || 1;
    });
    var heroStyle = computed(function () {
      return loss.value ? {
        background: BRAND.negSoft,
        border: "1px solid ".concat(BRAND.neg, "33")
      } : {
        background: "linear-gradient(135deg, ".concat(BRAND.posSoft, ", #fff)"),
        border: "1px solid ".concat(BRAND.pos, "33")
      };
    });
    var embedSnippet = computed(function () {
      return buildEmbedSnippet({
        pageUrl: pageUrl.value,
        iframeTitle: 'Amazon Australia Fee & Profit Calculator by SaleHoo',
        initialHeight: 1600
      });
    });
    function copySummary() {
      return _copySummary.apply(this, arguments);
    }
    function _copySummary() {
      _copySummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var didCopy;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return writeToClipboard(['Amazon AU sale — estimate', "".concat(PLANS[inputs.plan].label, " \xB7 ").concat(catLabel.value, " \xB7 ").concat(inputs.fulfilment.toUpperCase()), "Price ".concat(fmt(inputs.soldPrice), " + ship ").concat(fmt(inputs.shippingCharged), " = ").concat(fmt(result.value.total)), "Amazon fees ".concat(fmt(result.value.totalFees), " (").concat(pct(result.value.effFeeRate), ")  \xB7  costs ").concat(fmt(result.value.costs)), "Net profit ".concat(fmt(result.value.netProfit), " \xB7 margin ").concat(pct(result.value.margin)).concat(result.value.roi != null ? " \xB7 ROI ".concat(pct(result.value.roi)) : '')].join('\n'));
            case 2:
              didCopy = _context.sent;
              if (didCopy) {
                _context.next = 6;
                break;
              }
              resetCopied();
              return _context.abrupt("return");
            case 6:
              triggerCopied();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _copySummary.apply(this, arguments);
    }
    function copyEmbed() {
      return _copyEmbed.apply(this, arguments);
    }
    function _copyEmbed() {
      _copyEmbed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var didCopy;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return writeToClipboard(embedSnippet.value);
            case 2:
              didCopy = _context2.sent;
              if (didCopy) {
                _context2.next = 6;
                break;
              }
              resetEmbedCopied();
              return _context2.abrupt("return");
            case 6:
              triggerEmbedCopied();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _copyEmbed.apply(this, arguments);
    }
    function resetData() {
      Object.assign(inputs, blank);
      targetProfit.value = 0;
      targetMargin.value = 0;
      reverseTab.value = 'breakeven';
      showAdvanced.value = false;
      resetCopied();
      resetEmbedCopied();
      showPreview.value = false;
    }
    return function (_ctx, _cache) {
      var _REF$inputs$categoryI, _TIERS$find;
      return _openBlock(), _createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef,
        "class": _normalizeClass(['az', {
          embed: _unref(isEmbed)
        }])
      }, [_createElementVNode("div", _hoisted_1, [_unref(isEmbed) ? (_openBlock(), _createElementBlock("header", _hoisted_2, _cache[23] || (_cache[23] = [_createElementVNode("h1", {
        "class": "az-disp"
      }, " Amazon Australia Fee & Profit Calculator ", -1)]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("section", _hoisted_5, [_cache[24] || (_cache[24] = _createElementVNode("h2", {
        "class": "az-disp az-section-title"
      }, " Your seller plan ", -1)), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PLAN_KEYS), function (planKey) {
        return _openBlock(), _createElementBlock("button", {
          key: planKey,
          type: "button",
          "class": _normalizeClass(['az-chip', 'az-plan-chip', {
            on: inputs.plan === planKey
          }]),
          onClick: function onClick($event) {
            return setValue('plan', planKey);
          }
        }, [_createVNode(_unref(SvgIcon), {
          name: PLAN_ICONS[planKey],
          size: 16,
          style: _normalizeStyle({
            color: inputs.plan === planKey ? BRAND.brand : BRAND.faint
          })
        }, null, 8, ["name", "style"]), _createElementVNode("span", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(PLANS[planKey].label), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(PLANS[planKey].sub), 1)])], 10, _hoisted_7);
      }), 128))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
        type: "button",
        "class": _normalizeClass({
          on: inputs.fulfilment === 'fba'
        }),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return setValue('fulfilment', 'fba');
        })
      }, " Fulfilment by Amazon (FBA) ", 2), _createElementVNode("button", {
        type: "button",
        "class": _normalizeClass({
          on: inputs.fulfilment === 'fbm'
        }),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return setValue('fulfilment', 'fbm');
        })
      }, " I ship it myself (FBM) ", 2)])])]), _createElementVNode("section", _hoisted_13, [_cache[28] || (_cache[28] = _createElementVNode("h2", {
        "class": "az-disp az-section-title"
      }, " Sale data ", -1)), _createElementVNode("div", _hoisted_14, [_createVNode(_unref(FieldInput), {
        label: "Amazon selling price",
        hint: "The buyer-facing price. Referral fee applies to this.",
        "model-value": inputs.soldPrice,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return setValue('soldPrice', $event);
        })
      }, null, 8, ["model-value"]), _createVNode(_unref(FieldInput), {
        label: "Shipping charged to buyer",
        hint: "Usually $0 on FBA/Prime. Referral fee applies to it too.",
        "model-value": inputs.shippingCharged,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return setValue('shippingCharged', $event);
        })
      }, null, 8, ["model-value"]), _createVNode(_unref(FieldInput), {
        label: "Your product cost",
        hint: "Cost of goods per unit.",
        "model-value": inputs.itemCost,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return setValue('itemCost', $event);
        })
      }, null, 8, ["model-value"]), inputs.fulfilment === 'fbm' ? (_openBlock(), _createBlock(_unref(FieldInput), {
        key: 0,
        label: "Your shipping cost",
        hint: "What postage costs you to send each unit.",
        "model-value": inputs.shippingCost,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return setValue('shippingCost', $event);
        })
      }, null, 8, ["model-value"])) : (_openBlock(), _createBlock(_unref(FieldInput), {
        key: 1,
        label: "Unit weight (g)",
        hint: "For parcels & oversize, use the greater of actual weight or dimensional weight (L×W×H ÷ 4000, in kg).",
        prefix: "",
        step: "1",
        "model-value": inputs.weightG,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return setValue('weightG', $event);
        })
      }, null, 8, ["model-value"]))]), _createElementVNode("div", _hoisted_15, [_createElementVNode("label", _hoisted_16, [_cache[25] || (_cache[25] = _createElementVNode("span", {
        "class": "az-label"
      }, "Product category", -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("select", {
        value: inputs.categoryId,
        onChange: _cache[7] || (_cache[7] = function ($event) {
          return setValue('categoryId', $event.target.value);
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SORTED_CATS), function (category) {
        return _openBlock(), _createElementBlock("option", {
          key: category.id,
          value: category.id
        }, _toDisplayString(category.label), 9, _hoisted_19);
      }), 128))], 40, _hoisted_18)])]), inputs.fulfilment === 'fba' ? (_openBlock(), _createElementBlock("label", _hoisted_20, [_cache[26] || (_cache[26] = _createElementVNode("span", {
        "class": "az-label"
      }, "FBA size tier", -1)), _createElementVNode("div", _hoisted_21, [_createElementVNode("select", {
        value: inputs.sizeTier,
        onChange: _cache[8] || (_cache[8] = function ($event) {
          return setValue('sizeTier', $event.target.value);
        })
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(TIERS, function (tier) {
        return _createElementVNode("option", {
          key: tier.id,
          value: tier.id
        }, _toDisplayString(tier.label) + " — " + _toDisplayString(tier.dims), 9, _hoisted_23);
      }), 64))], 40, _hoisted_22)])])) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_24, _toDisplayString(catLabel.value) + ": referral fee " + _toDisplayString(pct(result.value.refRate)) + " on this sale" + _toDisplayString((_REF$inputs$categoryI = REF[inputs.categoryId]) !== null && _REF$inputs$categoryI !== void 0 && _REF$inputs$categoryI.media ? ' + $1.00 media closing fee' : '') + ". " + _toDisplayString(inputs.fulfilment === 'fba' && inputs.soldPrice < 13 && inputs.soldPrice > 0 ? ' Sub-$13 reduced FBA rate applied.' : ''), 1), tierOverflow.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_unref(SvgIcon), {
        name: "alertTriangle",
        size: 14,
        "class": "az-warning-icon",
        style: _normalizeStyle({
          color: BRAND.warn
        })
      }, null, 8, ["style"]), _createElementVNode("span", null, _toDisplayString(inputs.weightG) + " g exceeds the " + _toDisplayString((_TIERS$find = TIERS.find(function (tier) {
        return tier.id === inputs.sizeTier;
      })) === null || _TIERS$find === void 0 ? void 0 : _TIERS$find.label) + " limit (" + _toDisplayString(tierMaxLabel.value) + "). Pick a larger size tier for an accurate FBA fee.", 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [_createElementVNode("button", {
        type: "button",
        "class": "az-advanced-toggle",
        onClick: _cache[9] || (_cache[9] = function ($event) {
          return showAdvanced.value = !showAdvanced.value;
        })
      }, [_createElementVNode("span", _hoisted_27, [_createVNode(_unref(SvgIcon), {
        name: "layers",
        size: 16,
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[27] || (_cache[27] = _createTextVNode(" Advanced options "))]), _createVNode(_unref(SvgIcon), {
        name: showAdvanced.value ? 'chevronDown' : 'chevronRight',
        size: 16
      }, null, 8, ["name"])]), showAdvanced.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [inputs.plan === 'professional' ? (_openBlock(), _createBlock(_unref(FieldInput), {
        key: 0,
        label: "Units sold / month",
        hint: "Spreads the $49.95 Professional subscription across each unit.",
        prefix: "",
        step: "1",
        "model-value": inputs.unitsPerMonth,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
          return setValue('unitsPerMonth', $event);
        })
      }, null, 8, ["model-value"])) : _createCommentVNode("", true), inputs.fulfilment === 'fba' ? (_openBlock(), _createBlock(_unref(FieldInput), {
        key: 1,
        label: "FBA fee override",
        hint: "Know your exact fee from Seller Central? Enter it to override the table lookup.",
        "model-value": inputs.fbaOverride,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
          return setValue('fbaOverride', $event);
        })
      }, null, 8, ["model-value"])) : _createCommentVNode("", true), _createVNode(_unref(FieldInput), {
        label: "Storage & prep / unit",
        hint: "FBA monthly storage, prep, labelling or inbound freight, per unit.",
        "model-value": inputs.storagePrep,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
          return setValue('storagePrep', $event);
        })
      }, null, 8, ["model-value"]), _createVNode(_unref(FieldInput), {
        label: "Advertising / unit",
        hint: "Average ad spend (Sponsored Products) per unit sold.",
        "model-value": inputs.advertising,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
          return setValue('advertising', $event);
        })
      }, null, 8, ["model-value"]), _createVNode(_unref(FieldInput), {
        label: "Other costs / unit",
        hint: "Packaging, returns provision, anything else per unit.",
        "model-value": inputs.otherCosts,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
          return setValue('otherCosts', $event);
        })
      }, null, 8, ["model-value"])]), _createVNode(_unref(ToggleCard), {
        label: "Not registered for GST",
        hint: "add 10% GST to Amazon fees",
        checked: inputs.gstOnFees,
        "onUpdate:checked": _cache[15] || (_cache[15] = function ($event) {
          return setValue('gstOnFees', $event);
        })
      }, null, 8, ["checked"]), _createVNode(_unref(ToggleCard), {
        label: "Set aside GST on my revenue",
        hint: "".concat(inputs.gstRate, "% \u2014 your ATO obligation"),
        checked: inputs.remitGst,
        "onUpdate:checked": _cache[16] || (_cache[16] = function ($event) {
          return setValue('remitGst', $event);
        })
      }, null, 8, ["hint", "checked"])])) : _createCommentVNode("", true)])]), _createElementVNode("section", _hoisted_30, [_createElementVNode("h2", _hoisted_31, [_createVNode(_unref(SvgIcon), {
        name: "trendingUp",
        size: 16,
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[29] || (_cache[29] = _createTextVNode(" Net profit by plan "))]), _cache[30] || (_cache[30] = _createElementVNode("p", {
        "class": "az-note az-faint"
      }, " Same sale on each plan. Professional’s $49.95/mo pays for itself above ~50 sales a month. ", -1)), _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planCompare.value, function (plan) {
        return _openBlock(), _createElementBlock("div", {
          key: plan.key,
          "class": "az-compare-row"
        }, [_createElementVNode("span", {
          "class": "az-compare-label",
          style: _normalizeStyle({
            color: inputs.plan === plan.key ? BRAND.ink : BRAND.muted,
            fontWeight: inputs.plan === plan.key ? 700 : 400
          })
        }, _toDisplayString(plan.label), 5), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", {
          "class": "az-compare-fill",
          style: _normalizeStyle({
            width: "".concat(Math.max(0, Math.min(100, plan.net / (Math.max.apply(Math, _toConsumableArray(planCompare.value.map(function (entry) {
              return entry.net;
            }))) || 1)) * 100), "%"),
            background: plan.net < 0 ? BRAND.neg : Math.abs(plan.net - Math.max.apply(Math, _toConsumableArray(planCompare.value.map(function (entry) {
              return entry.net;
            })))) < 0.005 ? BRAND.pos : '#9fe2cb'
          })
        }, null, 4)]), _createElementVNode("span", {
          "class": "az-num az-compare-value",
          style: _normalizeStyle({
            color: plan.net < 0 ? BRAND.neg : BRAND.ink
          })
        }, _toDisplayString(fmt(plan.net)), 5)]);
      }), 128))])])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("section", {
        "class": "az-hero-card",
        style: _normalizeStyle(heroStyle.value)
      }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(loss.value ? 'You lose on this sale' : 'You take home'), 1), _createElementVNode("button", {
        type: "button",
        "class": "az-btn az-copy-btn",
        onClick: copySummary
      }, [_createVNode(_unref(SvgIcon), {
        name: _unref(copied) ? 'check' : 'copy',
        size: 12,
        style: _normalizeStyle(_unref(copied) ? {
          color: BRAND.pos
        } : {})
      }, null, 8, ["name", "style"]), _createTextVNode(" " + _toDisplayString(_unref(copied) ? 'Copied' : 'Copy'), 1)])]), _createElementVNode("div", {
        "class": "az-num az-disp az-hero-value",
        style: _normalizeStyle({
          color: loss.value ? BRAND.neg : BRAND.pos700
        })
      }, _toDisplayString(fmt(result.value.netProfit)), 5), _createElementVNode("div", _hoisted_37, [_createElementVNode("span", null, [_cache[31] || (_cache[31] = _createTextVNode("Margin ")), _createElementVNode("b", _hoisted_38, _toDisplayString(pct(result.value.margin)), 1)]), result.value.roi != null ? (_openBlock(), _createElementBlock("span", _hoisted_39, [_cache[32] || (_cache[32] = _createTextVNode("ROI ")), _createElementVNode("b", _hoisted_40, _toDisplayString(pct(result.value.roi)), 1)])) : _createCommentVNode("", true), _createElementVNode("span", null, [_cache[33] || (_cache[33] = _createTextVNode("Amazon’s cut ")), _createElementVNode("b", _hoisted_41, _toDisplayString(pct(result.value.effFeeRate)), 1)])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, function (segment) {
        return _openBlock(), _createElementBlock("div", {
          key: segment.label,
          "class": "az-segment-fill",
          style: _normalizeStyle({
            width: "".concat(segment.value / segmentTotal.value * 100, "%"),
            background: segment.color
          }),
          title: "".concat(segment.label, ": ").concat(fmt(segment.value))
        }, null, 12, _hoisted_44);
      }), 128))]), _createElementVNode("div", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, function (segment) {
        return _openBlock(), _createElementBlock("span", {
          key: segment.label,
          "class": "az-legend-item"
        }, [_createElementVNode("span", {
          "class": "az-legend-swatch",
          style: _normalizeStyle({
            background: segment.color
          })
        }, null, 4), _createTextVNode(" " + _toDisplayString(segment.label) + " " + _toDisplayString(fmt(segment.value)), 1)]);
      }), 128))])])], 4), loss.value ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(_unref(SvgIcon), {
        name: "alertTriangle",
        size: 16,
        "class": "az-warning-icon",
        style: _normalizeStyle({
          color: BRAND.warn
        })
      }, null, 8, ["style"]), _createElementVNode("span", null, [_cache[34] || (_cache[34] = _createTextVNode("This sale loses money. Raise the price to at least ")), _createElementVNode("b", null, _toDisplayString(fmt(breakeven.value)), 1), _cache[35] || (_cache[35] = _createTextVNode(" to break even."))])])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_47, [_cache[36] || (_cache[36] = _createElementVNode("h2", {
        "class": "az-disp az-section-title"
      }, " Fee & cost breakdown ", -1)), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_unref(BreakdownRow), {
        label: "Selling price",
        value: fmt(inputs.soldPrice)
      }, null, 8, ["value"]), _createVNode(_unref(BreakdownRow), {
        label: "Shipping charged",
        value: fmt(inputs.shippingCharged)
      }, null, 8, ["value"]), _createVNode(_unref(BreakdownRow), {
        label: "Total sale",
        value: fmt(result.value.total),
        strong: ""
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_50, [_createVNode(_unref(BreakdownRow), {
        label: "Referral fee",
        sub: pct(result.value.refRate),
        value: "\u2013 ".concat(fmt(result.value.referralFee)),
        tone: "neg"
      }, null, 8, ["sub", "value"]), result.value.perItem > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 0,
        label: "Per-item fee",
        sub: "Individual",
        value: "\u2013 ".concat(fmt(result.value.perItem)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true), result.value.mediaClosing > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 1,
        label: "Media closing fee",
        value: "\u2013 ".concat(fmt(result.value.mediaClosing)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true), result.value.fba > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 2,
        label: "FBA fulfilment fee",
        value: "\u2013 ".concat(fmt(result.value.fba)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true), result.value.subPerUnit > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 3,
        label: "Subscription / unit",
        sub: "Professional",
        value: "\u2013 ".concat(fmt(result.value.subPerUnit)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true), _createVNode(_unref(BreakdownRow), {
        label: "Total Amazon fees",
        value: "\u2013 ".concat(fmt(result.value.totalFees)),
        tone: "neg",
        strong: ""
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_51, [_createVNode(_unref(BreakdownRow), {
        label: "Product cost",
        value: "\u2013 ".concat(fmt(inputs.itemCost)),
        tone: "neg"
      }, null, 8, ["value"]), result.value.shipCost > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 0,
        label: "Your shipping",
        value: "\u2013 ".concat(fmt(result.value.shipCost)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true), inputs.storagePrep > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 1,
        label: "Storage & prep",
        value: "\u2013 ".concat(fmt(inputs.storagePrep)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true), inputs.advertising > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 2,
        label: "Advertising",
        value: "\u2013 ".concat(fmt(inputs.advertising)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true), inputs.otherCosts > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 3,
        label: "Other costs",
        value: "\u2013 ".concat(fmt(inputs.otherCosts)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true), result.value.gstOnRevenue > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 4,
        label: "GST set aside",
        sub: "your ATO obligation",
        value: "\u2013 ".concat(fmt(result.value.gstOnRevenue)),
        tone: "neg"
      }, null, 8, ["value"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_52, [_createVNode(_unref(BreakdownRow), {
        label: "Net profit",
        value: fmt(result.value.netProfit),
        tone: loss.value ? 'neg' : 'pos',
        strong: ""
      }, null, 8, ["value", "tone"])])])]), _createElementVNode("section", _hoisted_53, [_createElementVNode("h2", _hoisted_54, [_createVNode(_unref(SvgIcon), {
        name: "target",
        size: 16,
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[37] || (_cache[37] = _createTextVNode(" What price do I need? "))]), _createElementVNode("div", _hoisted_55, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(REVERSE_TABS, function (tab) {
        return _createElementVNode("button", {
          key: tab.key,
          type: "button",
          "class": _normalizeClass({
            on: reverseTab.value === tab.key
          }),
          onClick: function onClick($event) {
            return reverseTab.value = tab.key;
          }
        }, _toDisplayString(tab.label), 11, _hoisted_56);
      }), 64))]), reverseTab.value === 'breakeven' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_cache[38] || (_cache[38] = _createElementVNode("div", {
        "class": "az-output-label"
      }, " Sell at this price to break even ", -1)), _createElementVNode("div", _hoisted_58, _toDisplayString(!hasBasis.value ? '—' : notAchievable(breakeven.value) ? 'Not achievable' : fmt(breakeven.value)), 1)])) : reverseTab.value === 'profit' ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createVNode(_unref(FieldInput), {
        label: "Target profit per sale",
        "model-value": targetProfit.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
          return targetProfit.value = $event;
        })
      }, null, 8, ["model-value"]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_cache[39] || (_cache[39] = _createElementVNode("div", {
        "class": "az-output-label"
      }, "Sell at", -1)), _createElementVNode("div", _hoisted_62, _toDisplayString(!(hasBasis.value || targetProfit.value > 0) ? '—' : notAchievable(priceForProfit.value) ? 'Not achievable' : fmt(priceForProfit.value)), 1)]), _createElementVNode("div", _hoisted_63, [_cache[40] || (_cache[40] = _createElementVNode("div", {
        "class": "az-output-label"
      }, "Max product cost", -1)), _createElementVNode("div", {
        "class": "az-num az-disp az-output-value az-output-value-sm",
        style: _normalizeStyle({
          color: maxItemCost.value < 0 ? BRAND.neg : BRAND.ink
        })
      }, _toDisplayString(hasBasis.value || targetProfit.value > 0 ? fmt(maxItemCost.value) : '—'), 5)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_64, [_createVNode(_unref(FieldInput), {
        label: "Target margin %",
        prefix: "",
        step: "1",
        "model-value": targetMargin.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
          return targetMargin.value = $event;
        })
      }, null, 8, ["model-value"]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, " Sell at this price for a " + _toDisplayString(targetMargin.value) + "% margin ", 1), _createElementVNode("div", _hoisted_67, _toDisplayString(!(hasBasis.value || targetMargin.value > 0) ? '—' : notAchievable(priceForMargin.value) ? 'Not achievable' : fmt(priceForMargin.value)), 1), (hasBasis.value || targetMargin.value > 0) && notAchievable(priceForMargin.value) && maxMargin.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_68, " After fees, the most this sale can reach is about " + _toDisplayString(pct(maxMargin.value)) + ". ", 1)) : _createCommentVNode("", true)])]))]), _createElementVNode("button", {
        type: "button",
        "class": "az-btn az-reset",
        onClick: resetData
      }, [_createVNode(_unref(SvgIcon), {
        name: "rotateCcw",
        size: 14
      }), _cache[41] || (_cache[41] = _createTextVNode(" Reset data "))])])]), _unref(showEmbedCard) ? (_openBlock(), _createElementBlock("section", _hoisted_69, [_cache[42] || (_cache[42] = _createElementVNode("h2", {
        "class": "az-disp az-section-title az-section-title-tight"
      }, " Add calculator to your site ", -1)), _cache[43] || (_cache[43] = _createElementVNode("p", {
        "class": "az-embed-note az-faint"
      }, " Copy the snippet and paste it into any page or blog post. It resizes to fit and works on mobile. ", -1)), _createElementVNode("textarea", {
        "class": "az-embed-code az-num",
        readonly: "",
        rows: "4",
        value: embedSnippet.value,
        "aria-label": "Embed code",
        onClick: _cache[19] || (_cache[19] = function ($event) {
          return $event.target.select();
        })
      }, null, 8, _hoisted_70), _createElementVNode("div", _hoisted_71, [_createElementVNode("button", {
        type: "button",
        "class": "az-btn az-embed-copy",
        style: _normalizeStyle({
          background: BRAND.brand,
          color: '#fff',
          borderColor: BRAND.brand
        }),
        onClick: copyEmbed
      }, [_createVNode(_unref(SvgIcon), {
        name: _unref(embedCopied) ? 'check' : 'copy',
        size: 14
      }, null, 8, ["name"]), _createTextVNode(" " + _toDisplayString(_unref(embedCopied) ? 'Copied' : 'Copy embed code'), 1)], 4), _createElementVNode("button", {
        type: "button",
        "class": "az-btn az-embed-preview",
        onClick: _cache[20] || (_cache[20] = function ($event) {
          return showPreview.value = !_unref(showPreview);
        })
      }, _toDisplayString(_unref(showPreview) ? 'Hide preview' : 'Preview embed'), 1)])])) : _createCommentVNode("", true), _unref(isEmbed) ? (_openBlock(), _createElementBlock("p", _hoisted_72, _cache[44] || (_cache[44] = [_createTextVNode(" Powered by "), _createElementVNode("a", {
        href: "https://www.salehoo.com",
        target: "_blank",
        rel: "noopener"
      }, "SaleHoo", -1)]))) : _createCommentVNode("", true)]), _unref(showPreview) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "az-modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "amazon-au-preview-title",
        onClick: _cache[22] || (_cache[22] = _withModifiers(function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        }, ["self"]))
      }, [_createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_cache[45] || (_cache[45] = _createElementVNode("h3", {
        id: "amazon-au-preview-title",
        "class": "az-disp"
      }, " Embed preview ", -1)), _createElementVNode("button", {
        type: "button",
        "class": "az-modal-close",
        "aria-label": "Close preview",
        onClick: _cache[21] || (_cache[21] = function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        })
      }, [_createVNode(_unref(SvgIcon), {
        name: "x",
        size: 14
      })])]), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("iframe", {
        ref_key: "previewFrameRef",
        ref: previewFrameRef,
        "class": "az-preview-frame",
        src: _unref(previewSrc),
        title: "Embed preview",
        loading: "lazy"
      }, null, 8, _hoisted_77)])])])])) : _createCommentVNode("", true)], 2);
    };
  }
};